/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { Share } from 'src/app/models/share';
import {
    AddShare,
    ForceShareRefresh,
    RemoveShare,
    SetShares,
    ShareAction,
    UpdateShare,
} from './share.actions';

const featureName = 'share';

export interface ShareState {
    shares: Share[];
    forceRefresh: boolean;
}

const reducerMap: ActionReducerMap<ShareState> = {
    forceRefresh: forceRefreshReducer,
    shares: sharesReducer,
};

export const selectShareState = createFeatureSelector<ShareState>(featureName);
export const selectShares = createSelector(
    selectShareState,
    (state) => state.shares
);
export const selectShouldForceShareRefresh = createSelector(
    selectShareState,
    (state) => state.forceRefresh
);

export const shareStoreModule = StoreModule.forFeature(featureName, reducerMap);

function sharesReducer(state: Share[] = [], action: Action) {
    switch (action.type) {
        case ShareAction.addShare:
            return [...state, (action as AddShare).share];
        case ShareAction.removeShare:
            return state.filter(
                (share) => share.id !== (action as RemoveShare).shareId
            );
        case ShareAction.setShares:
            return [...(action as SetShares).shares];
        case ShareAction.updateShare:
            return [
                ...state.filter(
                    (share) => share.id !== (action as UpdateShare).share.id
                ),
                (action as UpdateShare).share,
            ];
        default:
            return state;
    }
}

function forceRefreshReducer(state = true, action: Action) {
    switch (action.type) {
        case ShareAction.forceShareRefresh:
            return (action as ForceShareRefresh).forceRefresh;
        default:
            return state;
    }
}
